// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ConditionOp } from "./condition-op";

/**
 * Condition evaluated against the original message's field values.
 * All conditions in a modifier are evaluated as logical AND.
 */
export class ModifierCondition implements flatbuffers.IUnpackableObject<ModifierConditionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifierCondition {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModifierCondition(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierCondition,
  ): ModifierCondition {
    return (obj || new ModifierCondition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsModifierCondition(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierCondition,
  ): ModifierCondition {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModifierCondition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  fieldPath(): string;
  fieldPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  fieldPath(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  op(): ConditionOp {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConditionOp.EQ;
  }

  valueText(): string | null;
  valueText(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  valueText(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startModifierCondition(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addFieldPath(builder: flatbuffers.Builder, fieldPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, fieldPathOffset, 0);
  }

  static addOp(builder: flatbuffers.Builder, op: ConditionOp) {
    builder.addFieldInt8(1, op, ConditionOp.EQ);
  }

  static addValueText(builder: flatbuffers.Builder, valueTextOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, valueTextOffset, 0);
  }

  static endModifierCondition(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // field_path
    return offset;
  }

  static createModifierCondition(
    builder: flatbuffers.Builder,
    fieldPathOffset: flatbuffers.Offset,
    op: ConditionOp,
    valueTextOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ModifierCondition.startModifierCondition(builder);
    ModifierCondition.addFieldPath(builder, fieldPathOffset);
    ModifierCondition.addOp(builder, op);
    ModifierCondition.addValueText(builder, valueTextOffset);
    return ModifierCondition.endModifierCondition(builder);
  }

  unpack(): ModifierConditionT {
    return new ModifierConditionT(this.fieldPath(), this.op(), this.valueText());
  }

  unpackTo(_o: ModifierConditionT): void {
    _o.fieldPath = this.fieldPath();
    _o.op = this.op();
    _o.valueText = this.valueText();
  }

  unpackFields(...fields: string[]): ModifierConditionT {
    const t = new ModifierConditionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("field_path")) {
      t.fieldPath = this.fieldPath();
    }
    if (fieldSet.has("op")) {
      t.op = this.op();
    }
    if (fieldSet.has("value_text")) {
      t.valueText = this.valueText();
    }
    return t;
  }
}

export class ModifierConditionT implements flatbuffers.IGeneratedObject {
  constructor(
    public fieldPath: string | Uint8Array | null = null,
    public op: ConditionOp = ConditionOp.EQ,
    public valueText: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fieldPath === null || this.fieldPath === undefined) {
      throw new Error('Required field "field_path" is not set');
    }
    const fieldPath = this.fieldPath !== null ? builder.createString(this.fieldPath!) : 0;
    const valueText = this.valueText !== null ? builder.createString(this.valueText!) : 0;

    return ModifierCondition.createModifierCondition(builder, fieldPath, this.op, valueText);
  }

  clone(): ModifierConditionT {
    const obj = new ModifierConditionT();
    obj.fieldPath = this.fieldPath;
    obj.op = this.op;
    obj.valueText = this.valueText;
    return obj;
  }

  equals(other: ModifierConditionT): boolean {
    if (this.fieldPath !== other.fieldPath) return false;
    if (this.op !== other.op) return false;
    if (this.valueText !== other.valueText) return false;
    return true;
  }
}

export function verifyModifierCondition(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "field_path");
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
